export default __webpack_public_path__ + "static/media/总磷.2c6f5a01.png";